module.exports = __webpack_public_path__ + "img/chat_bck.1a61576c.jpeg";